export default __webpack_public_path__ + "static/media/contacts-green-icon.68d91b02.svg";